/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useState } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Loading from "../Loading";
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
const Faq = () => {

    const { t } = useTranslation();

    const { BaseUrl } = useContext(MyContext);
    const [faqList, setFaqList] = useState([]);
    const [expandedIndex, setExpandedIndex] = useState([]);
    const [loading, setLoading] = useState(true);

    useState(() => {
        window.scrollTo(0, 0);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                position => {
                    const lats = position.coords.latitude;
                    const longs = position.coords.longitude;

                    const UserId = secureLocalStorage.getItem("Userid") || "0";
                    axios.post(`${BaseUrl}user_api/u_faq.php`, { uid: UserId, lats, longs })
                        .then((res) => {
                            setFaqList(res.data.FaqData);
                            setLoading(false);
                        })
                        .catch((error) => {
                            console.error("faq.php", error);
                        });
                },
                err => {
                    console.error(err.message);
                }
            );
        } else {
            console.error('Geolocation is not supported by your browser.');
        }
    }, []);

    const handleChange = (index) => {
        if (expandedIndex.includes(index)) {
            setExpandedIndex(expandedIndex.filter(id => id !== index));
        } else {
            setExpandedIndex([...expandedIndex, index]);
        }
    };

    return (
        <div className="width_container">
            {!loading ? <div className="bg-white p-[30px] rounded-[30px] mt-[20px]">
                <div className="">
                    <span className='text-[15px] text-gray-700'>{t("Frequently asked questions")}</span>
                    <h1 className='font-bold text-[48px]'>{t("Helps & FAQs")}</h1>
                </div>
                <div className="mt-[20px]">
                    {faqList.map((item, index) => {
                        const isExpanded = expandedIndex.includes(index);
                        return (
                            <div key={index} className="mb-[8px]">
                                <Accordion style={{
                                    border: isExpanded ? '1px solid #0000ffb7' : '1px solid #e1e1e1', borderRadius: "10px"
                                }} expanded={isExpanded} onChange={() => handleChange(index)}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon style={{ color: isExpanded ? '#0000ffb7' : 'gray' }} />}
                                        aria-controls={`panel${index}-content`}
                                        id={`panel${index}-header`}
                                    >
                                        <Typography component="span">{item.question}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails className='text-gray-500'>{item.answer}</AccordionDetails>
                                </Accordion>
                            </div>
                        );
                    })}
                </div>
            </div>
                : <Loading />
            }
        </div>
    )
}

export default Faq
/* jshint ignore:end */